import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";

export class BeslutningTjeneste {

    static regNavn = "felles.tjenester.modulspesifikke.BeslutningTjeneste";

    static forInjisering() {
        return [BeslutningTjeneste]
    }

    constructor() {
    }


    static kunForslagTilBeslutninger(beslutninger:l.BeslutningModell[]):l.BeslutningModell[]{
        return _(beslutninger).filter(b => b.erForslag === true).value();
    }

    static kunIkkeForslagTilBeslutninger(beslutninger:l.BeslutningModell[]):l.BeslutningModell[]{
        return _(beslutninger).filter(b => b.erForslag !== true).value();
    }
    
}

